import Select from 'react-select';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const StyledSelect = styled(Select)`
  .react-select__control {
    border-radius: 8px;
    border: 1px solid ${themeGet('colors.black.80')};
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    font-family: 'Montserrat', sans-serif;
    padding: ${props => props.$padding || '0 16px'};
    &:hover {
      border: 1px solid ${themeGet('colors.black.60')};
      .react-select__placeholder,
      .react-select__single-value,
      .react-select__indicator {
        color: ${themeGet('colors.black.60')};
      }
    }
  }

  .react-select__control--is-focused {
    box-shadow: none;
    border-color: ${themeGet('colors.black.100')};
    .react-select__single-value,
    .react-select__placeholder {
      color: ${themeGet('colors.black.100')};
    }
  }

  .react-select__value-container {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;

    //this class appears to be from react-select
    .css-b8ldur-Input {
      margin: 0;
      padding: 0;
    }
  }

  .react-select__single-value {
    max-width: ${props => props.$width || '100px'};
  }

  .react-select__indicator {
    padding: 0;
    color: ${themeGet('colors.black.80')};
  }

  .react-select__indicator-separator {
    margin-left: 10px;
    margin-right: 10px;
  }

  .react-select__placeholder {
    color: ${themeGet('colors.black.80')};
    margin: 0;
  }

  .react-select__menu {
    min-width: 100%;
    border-radius: 8px;
  }
  .react-select__option {
    display: flex !important;
    align-items: center;
    line-height: 18px;
  }
  .react-select__single-value {
    margin: 0;
    position: initial;
    transform: initial;
  }
`;
